import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import NonlalinDisposisi from '../../../utilities/nonlalin/NonlalinDisposisi'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import UserService from '../../../services/user/UserService'
import PbUmkuService from '../../../services/pbumku/PbumkuService'
import { AsyncPaginate } from 'react-select-async-paginate'
import DataTable from 'react-data-table-component'
import { formatDateString, getCurrentDateFormatted, romanNum } from '../../../utilities/Utils'
import ExpandableComponentNonLalinLHP from '../expand/ExpandableComponentNonLalinLHP'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalLhpNonLalin = ({ showAddLhp, handleCloseAddLhp, dataDisposisi, datappm, reloadList, isEdit }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)
    const [dataDetil, setDataDetil] = useState(null)
    const [valueTglDiagnosa, setValueTglDiagnosa] = useState(getCurrentDateFormatted())

    const [valueSppOpt, setValueSppOpt] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const resLhpHeader = await nonLalinService.getNonlalinLhpHeader(datappm.nomorAju, dataDisposisi.noTugas)

            if (resLhpHeader.data) {

                const resDtl = await nonLalinService.listNonlalinDtlAll(datappm.nomorAju)
                setDataDetil(resDtl.data)

                const results = await Promise.allSettled([
                    userService.getPegawaiById(resLhpHeader?.data?.nipTtd),
                    userService.getPegawaiById(resLhpHeader?.data?.nipPeriksa),
                ])

                const [resPejabat, resPetugas] = results
                const getData = (res, fallback = []) =>
                    res.status === "fulfilled"
                        ? res.value?.data?.data ?? res.value?.data ?? fallback
                        : fallback;

                setValuePejabatOpt(getData(resPejabat))
                setValuePegawaiOpt(getData(resPetugas))

                const resPenugasan = await nonLalinService.listNonlalinPenugasanByAjuAndIdDispo(datappm?.nomorAju, 2)
                const mappedSelected = resPenugasan.data.data.find(item => item.noTugas === resLhpHeader?.data?.nomorSpp)
                setValueSppOpt(mappedSelected)
                setVisibleDtl(true)
                setIdLhpHdr(resLhpHeader?.data?.id)
                setValueTglDiagnosa(resLhpHeader?.data?.tglDiagnosa)
            }
        } catch (error) {
            setDataDetil(null)
        }

    }, [nonLalinService, datappm, dataDisposisi, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    const onChangeTglDiagnosa = e => {
        setValueTglDiagnosa(e.target.value)
    }

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionSpp(search, loadedOption, { page = 1 }) {
        const response = await nonLalinService.listNonlalinPenugasanByAjuAndIdDispo(datappm?.nomorAju, 2)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const onChangePegawaiOpt = e => {
        setValuePegawaiOpt(e)
        // console.log(e)
    }

    const onChangeSppOpt = e => {
        setValueSppOpt(e)
    }

    const [showConfirmSaveHdr, setShowConfirmSaveHdr] = useState(false)
    const handleCloseConfirmSaveHdr = () => setShowConfirmSaveHdr(false)
    const [showSaveHdrSuccess, setShowSaveHdrSuccess] = useState(false)
    const [showSaveHdrFailed, setShowSaveHdrFailed] = useState(false)
    const [loadingSave, setLoadingSave] = useState(false)
    const [visibleDtl, setVisibleDtl] = useState(false)

    const [idLhpHdr, setIdLhpHdr] = useState(null)
    const [rowDisposisi, setRowDisposisi] = useState(null)

    const ProsesSimpanHdr = (dataDisposisi) => {
        setShowConfirmSaveHdr(true)
        setRowDisposisi(dataDisposisi)
    }

    const handleClickSaveHdr = async () => {
        setLoadingSave(true)
        try {
            const respNomor = await pbumkuService.ambilNomorService("NLL_LHPLAB", datappm.kodeUpt, currentYear, localStorage.getItem('username'))
            let noSuratTugas = respNomor.data.uraianPusat + '/' + datappm.kodeUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsoNLhp = { ...rowDisposisi, noTugas: noSuratTugas, tglTugas: getCurrentDateFormatted(), createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resLhp = await nonLalinService.saveNonlalinPenugasan(jsoNLhp)
            if (_resLhp.data.kode === '200') {
                let dataStatus = {
                    nomorAju: datappm.nomorAju,
                    kodeStatus: '026',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))

                let jsonLhpHdr = {
                    nomorAju: datappm.nomorAju,
                    nomorSpp: valueSppOpt.noTugas,
                    nomorLhp: noSuratTugas,
                    tglDiagnosa: valueTglDiagnosa,
                    nipPeriksa: valuePegawaiOpt.nip,
                    nmPeriksa: valuePegawaiOpt.nama,
                    jabPeriksa: valuePegawaiOpt.jabatan,
                    nipTtd: valuePejabatOpt.nip,
                    nmTtd: valuePejabatOpt.nama,
                    jabTtd: valuePejabatOpt.jabatan,
                    createdBy: localStorage.getItem("userId"),
                    createdDate: new Date()
                }
                let _resSaveHdr = await nonLalinService.saveNonlalinLhpHeader(jsonLhpHdr)
                if (_resSaveHdr.data.kode === '200') {
                    // console.log(_resSaveHdr)
                    setShowSaveHdrSuccess(true)
                    setShowConfirmSaveHdr(false)
                    setIdLhpHdr(_resSaveHdr.data.id)
                    setVisibleDtl(true)

                    let dataPpm = { ...datappm, status: '026' }
                    await nonLalinService.saveNonlalinHeader(dataPpm)
                } else {
                    setShowSaveHdrFailed(true)
                    setShowConfirmSaveHdr(false)
                }
            }
        } catch (error) {
            setShowSaveHdrFailed(true)
            setShowConfirmSaveHdr(false)
        }
        setLoadingSave(false)
    }

    const handleClickSaveHdrSuccess = () => {
        setShowSaveHdrSuccess(false)
        setShowConfirmSaveHdr(false)
        // reloadList(datappm.nomorAju)
        // setVisibleDtl(true)
    }

    const handleClickSaveHdrFailed = () => {
        setShowConfirmSaveHdr(false)
        setShowSaveHdrFailed(false)
    }

    const handleClickBatal = () => {
        handleCloseAddLhp()
        reloadList(datappm.nomorAju)
    }

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trNonlalinDtlPK'].seri,
            grow: 0
        },
        {
            name: 'Nama Dagang',
            cell: row => row['namaLokal']
        },
        {
            name: 'Nama Latin',
            cell: row => row['namaLatin']
        },
        {
            name: 'Keterangan / Populasi',
            cell: row => row['populasi']
        },
    ]

    return (
        <>
            <Modal
                show={showAddLhp}
                onHide={handleCloseAddLhp}
                size='xl'
                backdrop='static'
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5><NonlalinDisposisi idDisposisi={dataDisposisi.idDisposisi} /></h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className='col-4'>
                            <label className="col-sm-6 col-form-label-sm">Nomor Aju</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} disabled />
                            </div>
                        </div>
                        <div className='col-4'>
                            <label className="col-sm-6 col-form-label-sm">Tanggal Aju</label>
                            <div className="col-sm-6">
                                <input type="text" className="col-sm-12 form-control-sm" name="tanggal_aju" defaultValue={formatDateString(datappm.tanggalAju)} disabled />
                            </div>
                        </div>
                        {/* </div>
                    <div className="row mb-3"> */}
                        <div className='col-4'>
                            <label className="col-sm-8 col-form-label-sm">Tanggal Diagnosa <span className='text-danger'> *</span></label>
                            <div className="col-sm-12">
                                <input type="date" className="col-sm-12 form-control-sm" name="tgl_diagnosa" value={valueTglDiagnosa} onChange={onChangeTglDiagnosa} />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Surat Perintah</label>
                        <div className="col-sm-10">
                            <AsyncPaginate
                                loadOptions={loadOptionSpp}
                                value={valueSppOpt}
                                getOptionLabel={(option) => option.noTugas}
                                getOptionValue={(option) => option.noTugas}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeSppOpt}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-10">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Petugas Periksa</label>
                        <div className="col-sm-10">
                            <AsyncPaginate
                                loadOptions={loadOptionPegawai}
                                value={valuePegawaiOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePegawaiOpt}
                            />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className='col-sm-10'>
                            {isEdit && <Button variant="primary" size="sm" onClick={() => ProsesSimpanHdr(dataDisposisi)} disabled={visibleDtl}>Simpan Header</Button>}{' '}
                        </div>
                    </div>
                    {
                        dataDetil && visibleDtl &&
                        <div>
                            <DataTable
                                customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                columns={columns}
                                data={dataDetil.data}
                                highlightOnHover
                                persistTableHead={true}
                                expandableRows
                                expandOnRowDoubleClicked
                                expandableIcon={{
                                    collapsed: <span style={{ color: 'blue', fontWeight: 'bold' }}>Proses</span>,
                                    expanded: <span style={{ color: 'red', fontWeight: 'bold' }}>Tutup</span>,
                                }}
                                expandableRowsComponent={({ data }) => <ExpandableComponentNonLalinLHP data={data} idLhpHdr={idLhpHdr ? idLhpHdr : null} />}
                                expandableRowExpanded={() => true}
                            />
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" size="sm" onClick={() => handleClickBatal()}>
                        Kembali
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSaveHdr &&
                <SweetAlert
                    title="Simpan Data LHP ?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSaveHdr}
                    onCancel={handleCloseConfirmSaveHdr}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveHdrSuccess &&
                <SweetAlert
                    title="Simpat LHP Berhasil"
                    success
                    onConfirm={handleClickSaveHdrSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveHdrFailed &&
                <SweetAlert
                    title="Simpan LHP Gagal"
                    danger
                    onConfirm={handleClickSaveHdrFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalLhpNonLalin